import Vue from "vue";
import safePassword from "./safe-password.vue";
import { objAny } from "@/common/common-interface";
import sha256 from "js-sha256";
const SuccessBoxConstructor = Vue.extend(safePassword);

const getAnInstance = () => {
  return new SuccessBoxConstructor({
    el: document.createElement("div")
  });
};

const safePasswordBox: Function = (options: objAny = {}) => {
  const instance: objAny = getAnInstance();
  instance.formData = options.data || {};
  instance.returnData = options.returnData || true;

  instance.modalSafePassword = true;
  if (options.success) {
    instance.callBack = () => {
      options.success(sha256.sha256(instance.formInline.password));
      instance.close();
    };
  }
  document.body.appendChild(instance.$el);
  instance.close = () => {
    instance.modalSafePassword = false;
    setTimeout(() => {
      instance.$el.parentNode.removeChild(instance.$el);
    }, 600);
  };
};

export default safePasswordBox;
